import { useSnackbar } from 'notistack';
import { useMemo } from 'react';
import { ApiError } from '../api/client';

/** A readable message for any error thrown by the API layer. */
export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    const first = error.details[0];
    return first ? `${error.message} (${first.path}: ${first.message})` : error.message;
  }
  return 'Something went wrong. Please try again.';
}

export function useNotify() {
  const { enqueueSnackbar } = useSnackbar();
  return useMemo(
    () => ({
      success: (message: string) => enqueueSnackbar(message, { variant: 'success' }),
      info: (message: string) => enqueueSnackbar(message, { variant: 'info' }),
      error: (error: unknown) => enqueueSnackbar(errorMessage(error), { variant: 'error' }),
    }),
    [enqueueSnackbar],
  );
}
